var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.show = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }